


















































































































































































/* eslint-disable */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Modal from '@/components/Modal.vue';
import Button from '@/components/Button.vue';
import ModalDialog from '@/components/ModalDialog.vue';

import MerchantBillingList from './MerchantBillingList.vue';
import MerchantDetailTraffic from './MerchantDetailTraffic.vue';
import MerchantBillingSummary from './MerchantBillingSummary.vue';

import numberFormat from '@/libs/numberFormat';
import api from '@/libs/api';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Modal,
    Button,
    ModalDialog,

    MerchantBillingList,
    MerchantDetailTraffic,
    MerchantBillingSummary,
  },
  methods: {
    numberFormat,
  }
})

export default class MerchantDetail extends Vue {
  // mounted() {
  //   console.log('mounted', this.$store.state.user.user); // contoh ambil data dari store
  // }

  numberFormat!: typeof numberFormat;

  merchantDisclaim = false;
  showConfirmation = false;
  showDialog = false;
  showDetail = false;

  selectedPeriod: any[] = [];
  trafficPerDay: any[] = [];
  trafficDetail: any = {};

  submittedData: any;

  $refs!: {
    detailTraffic: MerchantDetailTraffic;
    billingList: MerchantBillingList;
    billingSummary: MerchantBillingSummary;
  }

  handleSelectPeriod($event: any[]) {
    this.selectedPeriod = $event;
    this.merchantDisclaim = false;
  }

  handleTrafficPerDayChanged($event: any[]) {
    this.trafficPerDay = $event;
  }

  handleCancelDisclaim() {
    this.$refs.detailTraffic.cancelChange();
  }

  handleDisclaim() {
    this.merchantDisclaim = true;
    this.$refs.detailTraffic.cancelChange();
  }

  handleConfirmClick($event: any) {
    console.log('confirm', $event);
    this.showConfirmation = true;
    this.submittedData = $event;
  }

  submitData() {
    try {
      if (this.isSinglePeriod) {
        if (this.merchantDisclaim) {
          let finalData: any[] = [];
          this.trafficPerDay.forEach((data: any) => {
            if (data.merchant_traffic != data.sprint_traffic) {
              finalData.push({
                id: data.id,
                traffic: data.merchant_traffic,
                amount: data.merchant_amount,
              });
            }
          });
          api.post('recon/traffic/update',
            {
              credential: this.submittedData.merchant_traffic[0].credential_code,
              periode: this.submittedData.merchant_traffic[0].periode_slug,
              // reason: 'no-reason',
              data: JSON.stringify(finalData),
              type: "1",
            }).then((result: any) => {
              if (result.data.status) {
                showToast(ToastType.SUCCESS, 'Disclaim Success', 'Our reconciliation team will check your disclaimed traffic');
                this.$refs.billingList.loadData();
                this.selectedPeriod = [];
                this.merchantDisclaim = false;
              } else {
                showToast(ToastType.FAILED, 'Disclaim Failed', result.data.message);
              }
            }).catch((error: any) => {
              showToast(ToastType.FAILED, 'Disclaim Failed', 'An Error Occured');
            })
        } else {
          api.post('recon/traffic/confirm',
            {
              credential: this.submittedData.merchant_traffic[0].credential_code,
              periode: this.submittedData.merchant_traffic[0].periode_slug,
              // reason: 'no-reason',
            }).then((result: any) => {
              if (result.data.status) {
                showToast(ToastType.SUCCESS, 'Confirm Success', 'Your billing has been successfully confirmed');
                this.$refs.billingList.loadData();
                this.selectedPeriod = [];
              } else {
                showToast(ToastType.FAILED, 'Confirm Failed', result.data.message);
              }
            }).catch((error: any) => {
              showToast(ToastType.FAILED, 'Confirm Failed', 'An Error Occured');
            })
        }
      } else {
        let finalData: any[] = [];
        this.submittedData.summaryData.listPeriode.forEach((data: any) => {
          finalData.push(`${data.periode_slug}#${data.credential_code}`)
        });

        // let form = new FormData();
        // form.append('reason', 'test');
        // form.append('data', finalData.toString());

        api.post('recon/traffic/confirm/batch',
          {
            // reason: 'no-reason',
            data: JSON.stringify(finalData),
          }).then((result: any) => {
            if (result.data.status) {
              showToast(ToastType.SUCCESS, 'Confirm Success', 'Your billing has been successfully confirmed');
              this.$refs.billingList.loadData();
              this.selectedPeriod = [];
            } else {
              showToast(ToastType.FAILED, 'Confirm Failed', result.data.message);
            }
          }).catch((error: any) => {
            showToast(ToastType.FAILED, 'Confirm Failed', 'An Error Occured');
          })
      }
    } catch (error) {
      console.log(error);
    }
  }

  async handleViewDetailClick($event: any) {
    try {
      const { data } = await api.get(`recon/traffic/${$event.item.merchant_code
        }/${$event.item2.credential_code
        }/${$event.item2.periode_slug}`);
      if (data.data) {
        this.trafficDetail = {
          item: $event.item,
          item2: $event.item2,
          data: data.data.traffic_per_day,
        };
      }
      this.showDetail = true;
    } catch (error) {
      console.log(error)
    }
  }

  hitungTotal(type: string, merchant_traffic: any[] = []) {
    try {
      let total = 0;
      switch (type) {
        case "sprint": {
          if (this.trafficDetail.data) {
            this.trafficDetail.data.forEach((data: any) => {
              total += parseInt(data.sprint_traffic || 0);
            })
          }
          return total;
        }
        case "merchant": {
          if (this.trafficDetail.data) {
            this.trafficDetail.data.forEach((data: any) => {
              total += parseInt(data.merchant_traffic || 0);
            })
          }
          return total;
        }
        case "difference": {
          if (this.trafficDetail.data) {
            this.trafficDetail.data.forEach((data: any) => {
              total += (parseInt(data.sprint_traffic || 0) - parseInt(data.merchant_traffic || 0));
            })
          }
          return total;
        }
        case "multiple": {
          merchant_traffic.forEach((data: any) => {
            total += parseInt(data.total_traffic || 0);
          })
        }
      }
      return total;
    } catch (error) {
      console.log(error);
    }
  }

  get isSinglePeriod() {
    try {
      if (this.selectedPeriod.length === 1) {
        if (this.selectedPeriod[0].merchant_traffic.length === 1) {
          return true;
        }
      }
      return false;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  async handleExport(params: any, file_name: string) {
    showToast(ToastType.SUCCESS, 'Export Transaction', 'Export is starting, please wait! This may take a while');
    this.$refs.billingSummary.loadingExport = true;
    await api.get('recon/traffic/export', {
      params,
      responseType: "arraybuffer"
    }).then((response) => {
      const url = window.URL.createObjectURL(
        new Blob([response.data])
      );
      let link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", file_name);
      document.body.appendChild(link);
      link.click();
      this.$refs.billingSummary.loadingExport = false;
    }).catch((error) => {
      console.log(error);
      this.$refs.billingSummary.loadingExport = false;
    })
  }
}
